import React from 'react';

import { importFromS3 } from '../../utils/importFromS3';

const OperationHubPlugin = React.lazy(() => importFromS3('tcc-operation-hub'));

export const OperationHubPluginContainer: React.FC = () => (
  <OperationHubPlugin />
);
